<template>
  <div class="attr-list">
    <el-form>
      <el-form-item>
        <el-radio v-model="curComponent.style.deviceType" label="IPC" @change="deviceTypeChange">摄像机</el-radio>
        <el-radio v-model="curComponent.style.deviceType" label="NVR" @change="deviceTypeChange">录像机</el-radio>
      </el-form-item>
      <el-form-item label="选择设备">
        <el-select v-model="curComponent.style.deviceId" :loading="deviceIdLoading" @change="deviceChange">
          <el-option v-for="item in deviceList" :key="item.deviceId" :label="item.deviceName" :value="item.deviceId" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="curComponent.style.deviceType==='NVR'" label="选择通道">
        <el-select v-model="curComponent.style.channelId" :loading="deviceIdLoading">
          <el-option v-for="item in channelList" :key="item.channelId" :label="item.channelName" :value="item.channelId" />
        </el-select>
      </el-form-item>
      <el-form-item label="多屏时切换屏幕时长">
        <el-select v-model="curComponent.style.duration">
          <el-option label="不轮播" :value="0" />
          <el-option label="5分钟" :value="5" />
          <el-option label="10分钟" :value="10" />
          <el-option label="30分钟" :value="30" />
          <el-option label="60分钟" :value="60" />
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { siteMonitorDeviceList, siteMonitorChannelList } from '@/api/device'
import { mapState } from 'vuex'
export default {
  components: { },
  data() {
    return {
      deviceList: [],
      deviceIdLoading: false,
      channelList: []
    }
  },
  computed: {
    ...mapState({
      projectItem: state => state.user.projectItem
    }),
    curComponent() {
      return this.$store.state.compose.curComponent
    }
  },
  mounted() {
    this.getDeviceList()
  },
  methods: {
    getDeviceList() {
      this.deviceIdLoading = true
      siteMonitorDeviceList({
        deviceType: this.curComponent.style.deviceType,
        businessId: this.projectItem.projectId,
        pageSize: 9999
      }).then(res => {
        this.deviceList = res.data.records
        if (this.curComponent.style.deviceType === 'IPC') {
          this.curComponent.deviceList = res.data.records
        } else {
          if (res.data.records && res.data.records.length > 0 && !this.curComponent.style.deviceId) {
            this.curComponent.style.deviceId = res.data.records[0].deviceId
          }
          if (this.curComponent.style.deviceId) {
            this.getChannelList()
          }
        }
      }).finally(() => {
        this.deviceIdLoading = false
      })
    },
    deviceTypeChange() {
      this.getDeviceList()
    },
    getChannelList() {
      siteMonitorChannelList({
        businessId: this.projectItem.projectId, deviceId: this.curComponent.style.deviceId
      }).then(res => {
        this.channelList = res.data
        if (this.curComponent.style.deviceType === 'NVR') {
          if (res.data && res.data.length > 0 && !this.curComponent.style.channelId) {
            this.curComponent.style.channelId = res.data[0].channelId
          }
          this.curComponent.deviceList = res.data
        }
      })
    },
    deviceChange() {
      if (this.curComponent.style.deviceType === 'NVR') {
        this.getChannelList()
      }
    }
  }
}
</script>
<style scoped>
.el-select{
  width: 100%;
}
</style>
